export const darkTheme = {
  id: 'dark',
  // color
  primary: 'rgba(65,132,228,0.15)',
  success: 'rgba(70,149,74,0.15)',
  warning: 'rgba(174,124,20,0.4)',
  danger: 'rgba(229,83,75,0.15)',
  toggleIcon: '#986ee2',
  // background
  primaryBg: '#22272e',
  secondaryBg: '#2d333b',
  borderColor: '#444c56',
  // text
  text: '#adbac7',
  mutedText: '#768390',
  headings: '#ffffff',
  accentHeadings: '#ffffff',
  links: '#539bf5',
  // button primary
  btnPrimaryText: '#539bf5',
  btnPrimaryTextHover: '#cdd9e5',
  btnPrimaryBg: 'rgba(65,132,228,0.15)',
  btnPrimaryBgHover: '#316dca',
  // button danger
  btnDangerBg: 'rgba(229,83,75,0.7)',
  btnDangerBgHover: 'rgba(229,83,75,0.6)',
  // opposit0e color
  oppositePrimaryBg: '#ffffff',
  oppositeSecondaryBg: '#f6f8fa',
  oppositeText: '#24292f',
  // etc
  transitionTime: '0.2s',
}
